"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FunnelChart = void 0;
var React = _interopRequireWildcard(require("react"));
var _highcharts = _interopRequireDefault(require("highcharts"));
var _funnel = _interopRequireDefault(require("highcharts/modules/funnel"));
var _highchartsReactOfficial = _interopRequireDefault(require("highcharts-react-official"));
var _charts = require("../../../utils/charts");
var _funnelChart = require("../../../utils/charts/funnelChart");
var _classify = _interopRequireDefault(require("../../../utils/classify"));
var _ChartWrapper = require("../ChartWrapper");
var _FunnelChartModule = _interopRequireDefault(require("./FunnelChart.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const FunnelChart = _ref => {
  let {
    isLoading,
    classNames,
    cardTitle,
    customExportOptions,
    series,
    headerActions,
    drilldown,
    showLegend = true,
    hasEmptyData,
    emptyText,
    testId,
    ...userOptions
  } = _ref;
  (0, _funnel.default)(_highcharts.default);
  const chartRef = /*#__PURE__*/React.createRef();
  const funnelChartSeries = (0, _funnelChart.addColorsToFunnelSeries)(series, showLegend);
  const defaultFunnelChartOptions = (0, _funnelChart.getFunnelChartOptions)();
  const columnDrilldown = drilldown ? {
    ...(0, _funnelChart.addColorsToFunnelDrilldownSeries)(drilldown, showLegend),
    breadcrumbs: {
      floating: false
    }
  } : {};
  const chartOptions = (0, _charts.mergeChartUserOptions)(defaultFunnelChartOptions, {
    series: funnelChartSeries,
    drilldown: columnDrilldown,
    ...userOptions
  });
  const {
    highChart,
    ...wrapperClassNames
  } = classNames || {};
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChartWrapper.ChartWrapper, {
    isLoading: isLoading,
    title: cardTitle,
    ref: chartRef,
    classNames: wrapperClassNames,
    customExportOptions: customExportOptions,
    headerActions: headerActions,
    hasEmptyData: hasEmptyData,
    emptyText: emptyText,
    testId: testId,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_highchartsReactOfficial.default, {
      highcharts: _highcharts.default,
      containerProps: {
        className: (0, _classify.default)(_FunnelChartModule.default.funnelChartContainer, highChart)
      },
      ref: chartRef,
      options: chartOptions
    })
  });
};
exports.FunnelChart = FunnelChart;